<template>
  <div class="studentWrap">
    <div class="student">
      <div class="stuHeader">
        <p class="title">
          <strong>
            <span v-if="course.info.is_special_train === 1">【快】</span>
            {{course.info.name}}
          </strong>
        </p>
        <div class="wrap">
          <p class="subtitle">（第{{course.info.periods}}期 主讲师：{{course.info.teacher_off_name}}）</p>
          <div class="btn" @click="lookOverRes">创建实践与考试教案</div>
        </div>
      </div>
      <div class="stuMain">
        <div class="up">
          <template v-if="course.showInfo">
            <div class="upCommon">
              <div class="imgWrap" @click="greetMoment">
                <img :src="!course.info.moment_picture ? imgSrc : course.info.moment_picture"
                     @error="imgError"
                     alt="">
                <div class="pos">
                  <yioks-status class="status" :status="course.info.status"></yioks-status>
                  <div class="btnWrap">
                    <div class="btn">精彩瞬间</div>
                  </div>
                </div>
              </div>
              <div class="details">
                <template v-if="course.info.class_level==='C' || course.info.class_level==='D' || course.info.class_train_type === 'continue_education'">
                  <p>培训日期：{{course.info.start_date | time(false)}} 至 {{course.info.end_date | time(false)}}</p>
                </template>
                <template v-else>
                  <p>培训第一阶段：{{course.dataPhase[0].start_date | time(false)}} 至 {{course.dataPhase[0].end_date | time(false)}}</p>
                  <p>培训第二阶段：{{course.dataPhase[1].start_date | time(false)}} 至 {{course.dataPhase[1].end_date | time(false)}}</p>
                </template>
                <p class="teacher">
                  <span>主讲师：{{ course.info.teacher_off_name }}</span>
                  <span v-if="course.info.teacher_name">助理讲师：{{course.info.teacher_name}}</span>
                </p>
                <p v-if="course.info.lecturer_assistant_name">
                  讲师助理：{{course.info.lecturer_assistant_name}}
                </p>
                <template v-if="course.info.class_level==='C' || course.info.class_level==='D' ">
                  <p>训练场地：{{course.info.training_address || '--'}}</p>
                  <p>理论课场地：{{course.info.theory_address || '--'}}</p>
                </template>
                <div class="wrapper-text" style="display: flex;">
                  <div class="service-item" v-if="course.info.class_qr_code">
                    <div style="display:flex; vertical-align:middle" >
                      <span style="margin-right: 10px;">班级群二维码:</span>
                      <v-icon name="qrcode" scale="1.15" style="color: #4cd964;"></v-icon>
                    </div>
                    <div class="item-common qrCode">
                      <div class="content">
                        <img :src="course.info.class_qr_code " alt="">
                      </div>
                    </div>
                  </div>
                  <div class="service-item" v-if="course.info.hours">
                    <div style="display:flex; vertical-align:middle;cursor:text" >
                      <span>学时: {{course.info.hours}}</span>
                    </div>
                  </div>
                  <div @click="showClassDetail=true"
                    style="cursor:pointer;color: #4cd964; text-decoration-line: underline; margin-right:10px;">
                    查看更多
                  </div>
                </div>
              </div>
            </div>
            <div class="scheduleWrap">
              <div class="schedule">
                <div class="btnWrap">
                  <p>课程表：</p>
                  <div class="btn check" @click="showSchedule">查看</div>
                  <a class="btn download"
                     :href="course.info.timetable_picture
                     ? course.info.timetable_picture
                     : getClassImg(course.info.class_level )"
                     download="">下载</a>
                </div>
              </div>
              <yioks-schedule :flag="scheduleFlag"
                              :dw="'900px'"
                              :level="course.info.class_level"
                              :class_train_type="course.info.class_train_type"
                              :pic.sync="course.info.timetable_picture"
                              @hide="hideSchedule($event)"></yioks-schedule>
            </div>
          </template>
        </div>
        <div class="down">
          <div class="left">
            <div v-if="course.showInfo"
                 v-for="(item, index) in course.list"
                 :key="index"
                 :class="{ item: true, active: activeIdx == index }"
                 @click="switchTab(index)">{{ item.name }}
            </div>
          </div>
          <div class="right">
            <div class="rightHead">
              <p class="title">{{ course.list[activeIdx] ? course.list[activeIdx].name : '' }}学员信息</p>
            </div>
            <div class="scro_wrap">
              <vue-scroll :ops="vuescrollOpt">
                <div class="s_cont">
                  <div class="item"
                 v-if="course.showList"
                 v-for="(item, index) in students"
                 :key="index">
              <div class="imgWrap">
                <img :src="!item.user_profile_picture ? userImg : item.user_profile_picture"
                     @error="imgListErr(index)"
                     alt="">
              </div>
              <div class="infoWrap">
                <div class="info">
                  <div class="line">
                    <p style="display: flex;align-items: center">姓名：{{ item.user_name }}
                      <span v-if="item.enroll_type==='make_up_exam'" >(补考)</span>
                    </p>
                    <p>性别：{{ item.gender == "Male" ? "男" : "女" }}</p>
                  </div>
                  <div class="line">
                    <p>手机：{{ item.mobile_phone }}</p>
                  </div>
                </div>
              </div>
            </div>
                </div>
              </vue-scroll>
            </div>

          </div>
        </div>
      </div>
    </div>
    <el-dialog class="eval-dialog"
               :visible.sync="allDisabled"
               title
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               width="460px"
               center>
      <div class="to-eval">
        <div class="img">
          <img src="@/assets/images/evaluation_tips.png" alt>
        </div>
        <div class="tips">
          <p v-html="tips.title"></p>
        </div>
        <el-button type="primary" @click="gotoSetting">{{tips.button_text}}</el-button>
      </div>
    </el-dialog>
    <!--<select-organ :organList="organList" @hideTips="hideTips" :showdialog="showSelectOrganDialog"></select-organ>-->
    <class-info-detail v-if="showClassDetail" :isShow.sync="showClassDetail" :classInfo="course.info" :dataPhase="course.dataPhase"></class-info-detail>
  </div>
</template>

<script>
import createScrollOpt from "@/assets/js/vuescrollOption";
  import Img from "@/assets/images/class_logo.png";
  import userImg from "@/assets/images/person.png";
  import ScheduleBg from "@/assets/images/schedule.png";
import class_d from "@/assets/images/timetable/class_d.png";
import class_c from "@/assets/images/timetable/class_c.jpg";
import class_a from "@/assets/images/timetable/class_a.jpg";
import class_b from "@/assets/images/timetable/class_b.png";
import class_education from '@/assets/images/timetable/class_education.jpg';
  import {
    classDetailInfo,
    classDetailList,
    getStuAccount,
    getGroupingList
  } from "@/api/common/api";
  import {isEvaluated} from "@/api/training_student/api";
  import {organList} from "@/api/ab_signup/api";

  export default {
    name: "class-detail",
    data() {
      return {
        vuescrollOpt: createScrollOpt(),
        organList:[],
        class_b,
        class_a,
        class_education,
        showClassDetail:false,
        showSelectOrganDialog:false,
        activeIdx: 0,
        imgSrc: Img,
        userImg: userImg,
        schedule: ScheduleBg,
        class_d,
        class_c,
        scheduleFlag: false,
        group_id: 1,
        team: "",
        students: [],
        course: {
          showInfo: false,
          showList: false,
          info: {},
          list: [],
          dataPhase:[],
        },
        tips:{
          title:"",
          button_text:"",
          show_type:"",
        },
        allDisabled: false,

      };
    },
    components: {
      "yioks-status": () => import("@/components/Tips/Status"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-schedule": () => import("@/components/Timetable/Schedule"),
//      "select-organ" :() => import('@/components/Tips/select-organ'),
      'class-info-detail' : () => import("@/components/ClassInfoBox/classInfoDetail"),
    },
    created() {
      this.setData();
      this.isEvaled();
      this.getClassInfo(() => {this.groupListInfo(this.changeQuery)});
    },
    methods: {
      getClassImg(level){
        if(this.course.info.class_train_type === 'train'){
          switch (level) {
            case "A" :
              return this.class_a;
              break;
            case "C" :
              return this.class_c;
              break;
            case "B" :
              return this.class_b;
              break;
            case "D" :
              return this.class_d;
              break;
          }
        }else{
          return this.class_education;
        }
      },
      isEvaled() {
        isEvaluated().then(({data}) => {
          if (data.status === 0) {
//            if (Number(data.result.binding_org)===1 && data.result.class_level === 'C'){
//              this.getOrganList();
//              return
//            }
            this.allDisabled = data.result.perfect_info === 1 || data.result.eva_show === 1 || Boolean(data.result.has_license);
            if(data.result.perfect_info === 1){
              this.tips.title="首次登录需要完善个人资料<br/>资料内容在培训结束前均可在“设置-->资料设置”中修改。";
              this.tips.button_text="前往完善资料";
              this.tips.show_type="perfect_info";
            }
            else if (data.result.eva_show === 1 ){
              this.tips.title="培训班即将结束，请您填写问卷调查。";
              this.tips.button_text="前往问卷调查";
              this.tips.show_type="eva_show";
            }
            else if (data.result.has_license){
              this.tips.title="您有新的教练员执照待领取，<br/>请填写领取信息";
              this.tips.button_text="前往填写";
              this.tips.show_type="licenseInfo";
            }
          }
        });
      },
      setData() {
        const {idx} = this.$route.query;
        idx && (this.activeIdx = Number(idx));
      },
      // 获取培训班分组列表
      groupListInfo(dosome = () => {}) {
        getGroupingList({c_id: this.course.info.c_id}).then(({ data }) => {
          if (data.status === 0) {
            const { list } = data.result;
            this.course.list = [...list]
            dosome()
          }
        });
      },
      getClassInfo(other = () => {}) {
        classDetailInfo({})
          .then(({data}) => {
            // console.log(res);
            this.$set(this.course, "info", data.result.class_info);
            this.$set(this.course, "dataPhase", data.result.dataPhase);
            // this.$set(this.course, "list", data.result.group_list);
            this.$set(this.course, "showInfo", true);
            other()
          })
          .catch(err => {
            console.error(err);
          });
      },
      req_list() {
        this.students = this.course.list[this.activeIdx].stu_list;
        this.$set(this.course, "showList", true);
      },
      imgError() {
        this.$set(this.course.info, "moment_picture", this.imgSrc);
      },
      imgListErr(idx) {
        this.$set(this.students[idx], "user_profile_picture", this.userImg);
      },
//      lookOverRes() {
//        this.$router.push({
//          path: "tutorial_res",
//          query: {
//            c_id: this.course.info.c_id
//          }
//        });
//      },
      lookOverRes() {
        this.$router.push({
          path: "tutorial_other",
          query: {
            res_type: 0
          }
        });
      },
      greetMoment() {
        // console.log("精彩瞬间~");
        this.$router.push({
          path: "won",
          query: {
            c_id: this.course.info.c_id
          }
        });
      },
      showSchedule() {
        this.scheduleFlag = true;
      },
      hideSchedule(bool) {
        this.scheduleFlag = bool;
      },
      switchTab(idx) {
        this.activeIdx = idx;
        this.changeQuery()
      },
      changeQuery() {
        this.activeIdx = this.activeIdx > this.course.list.length-1 ? 0:this.activeIdx
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            idx: this.activeIdx
          }
        });
        this.req_list();
      },
      gotoSetting(){
        if(this.tips.show_type === 'eva_show'){
          this.$router.push({name:'StuCreateEvaluation'});
        }else if(this.tips.show_type === 'perfect_info'){
          this.$router.push({
            path: "vita",
            query: {}
          });
        }else{
          this.$router.push({
            path: "getLicenseList",
            query: {}
          });
        }
      },
      hideTips(bool){
        if (bool){
          this.showSelectOrganDialog=false;
          this.isEvaled()
        }
      },
//      getOrganList(){
//        organList({}).then(
//          ({ data: { result, status } }) => {
//            if (status === 0) {
//              this.organList = result.list;
//              this.showSelectOrganDialog=true;
//            }
//          }
//        );
//      }
    }
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'

  .studentWrap
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center
    color $color_white
    .eval-dialog
      .to-eval
        font-size 16px
        text-align center
        img
          width 100px
        .tips
          margin-bottom 15px
    .student
      width 890px
      height 710px
    .stuHeader
      height 95px
      .title
        font-size 28px
        line-height 32px
        text-align center
        color $color_title;
        text-shadow : 2px 1px 3px #231815;
      .wrap
        height 40px
        margin 15px 0 0
        display flex
        justify-content center
        align-items center
        position relative
        .subtitle
          font-size 20px
          color $color_title;
          text-shadow : 2px 1px 3px #231815;
        .btn
          position absolute
          top 0
          right 0
          width 195px
          height 100%
          text-align center
          font-size $font_size_big
          line-height 40px
          background-color $color_suc
          cursor pointer
          user-select none
    .stuMain
      height 615px
      .up
        width 100%
        height 155px
        margin 0 0 10px
        display flex
        background-color $block_bg_color_base
        .upCommon
          padding 20px 0 10px 20px
          flex 1 1 auto
          display flex
          .imgWrap
            flex 0 0 auto
            position relative
            cursor pointer
            img
              width 150px
              height 115px
            .pos
              width 100%
              height 100%
              position absolute
              top 0
              left 0
              display flex
              flex-direction column
              user-select none
              .status
                margin 0 0 0 10px
              .btnWrap
                width 100%
                display flex
                justify-content center
                align-items center
                position absolute
                bottom 0
                .btn
                  width 100px
                  height 28px
                  margin 0 0 1px
                  display flex
                  justify-content center
                  align-items center
                  background-color $color_err
          .details
            max-width 440px
            padding 0 0 0 15px
            flex 1 1 auto
            display flex
            flex-direction column
            justify-content space-between
            font-size $font_size_medium
            line-height $font_size_big
            p
              word-break break-all
            .teacher
              span:first-child
                margin 0 20px 0 0
            .service-item{
              position relative
              cursor: pointer;
              margin-right 20px
              .item-common{
                display none
                position absolute
                z-index: 10000;
                top -200px
                right -100px
                width 250px
                height 250px
                .content {
                  padding: 10px  ;
                  justify-content: center;
                  align-items: center;
                  display: flex;
                  background-color: rgba(0,0,0,0.7);
        
                  img {
                    height 100%
                    width 100%
                    padding 5px
                    border 1px solid #ffffff
                  }
                }
      
              }
    
              &:hover{
                .qrCode {
                  display block
                }
              }
    
            }
        .scheduleWrap
          width: 269px;
          height: 147px;
          padding: 20px 30px 10px 0;
          box-sizing border-box
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction column
          .schedule
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            user-select: none;
            min-height 42px
            p
              margin 0 0 5px 0
              font-size 24px
            .btnWrap
              width: 100%;
              display: flex;
              border 1px dashed $color_white
              padding  5px 8px
              border-radius 5px
              p
                font-size 18px
                margin 0
                line-height 30px
              .btn
                width: 55px;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: $font_size_medium;
                cursor: pointer;
                margin 0 5px
                border-radius 5px
              .check
                background-color $color_suc
              .modify
                background-color $color_primary
              .download
                background-color $color_err
              .undownload
                background-color $color_info
                cursor not-allowed
      .down
        width 100%
        height calc(100% - 165px)
        display flex
        justify-content space-between
        .left, .right
          height 100%
          background-color $block_bg_color_base
        .left
          width 195px
          padding 0 30px
          .item
            width 100%
            height 36px
            margin 18px 0
            display flex
            justify-content center
            align-items center
            font-size $font_size_medium
            cursor pointer
            user-select none
          .active
            background-color $color_suc
        .right
          width 685px
          .rightHead
            display flex
            align-items center
            padding 0 20px
            .title
              padding 20px 0 10px
              font-size $font_size_big
          .scro_wrap
            display block
            height 375px
            overflow hidden
            .s_cont
              display blcok
              padding 0 20px
          .item
            width 100%
            /*height 125px*/
            padding 5px 0
            display flex
            border-top 1px solid $color_white
            &:last-child
              border-bottom 1px solid $color_white
            .imgWrap
              height 80px
              padding 0 20px 0 5px
              flex 0 0 auto
              img
                width 80px
                height 80px
                border-radius 50%
            .infoWrap
              flex 1 1 auto
              display flex
              justify-content space-between
              .info
                display flex
                flex-direction column
                justify-content space-around
                font-size $font_size_medium
                .line
                  display flex
                  p
                    margin 0 20px 0 0
</style>
